import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import "./GoogleCalendarPopup.scss";

export const GOOGLE_CALENDAR_GENERAL_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ2xuc0PDo0sPrN3TSUoU4ZberdT74bK8Y00sis85CEAVxMBgkxfNxP_5gyXi8WpmlZXAYisQlL6?gv=true";

export const GOOGLE_CALENDAR_FEASIBILITY_AUDIT_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ0dB_pe5gUJKCqihbuyVnakHWzBmwq5sF3X60s-Oa_QHM34ZtZJips3qZM2qiJxlEeWBuCe8HUn?gv=true";

export const GOOGLE_CALENDAR_SCHEDULE_URL = GOOGLE_CALENDAR_GENERAL_URL;

export default function GoogleCalendarPopup({
  url = GOOGLE_CALENDAR_GENERAL_URL,
  label = "Book an appointment",
  id,
  className = "",
  style = {},
  variant,
  as,
  children,
  show: controlledShow,
  onHide: controlledOnHide,
  modalTitle,
  ...rest
}) {
  const [internalShow, setInternalShow] = useState(false);
  const isControlled = controlledShow !== undefined;
  const showModal = isControlled ? controlledShow : internalShow;

  const handleOpen = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!isControlled) {
      setInternalShow(true);
    }
  };

  const handleClose = useCallback(() => {
    if (isControlled) {
      if (controlledOnHide) controlledOnHide();
    } else {
      setInternalShow(false);
    }
  }, [isControlled, controlledOnHide]);

  useEffect(() => {
    const handleMessage = (e) => {
      // Catch postMessage from scheduling tools if emitted
      if (
        e.data &&
        (e.data.event === "calendly.event_scheduled" ||
          e.data.event === "google.calendar.event_scheduled" ||
          e.data === "booking_confirmed")
      ) {
        handleClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [handleClose]);

  return (
    <>
      {as === "span" ? (
        <span
          id={id}
          className={className}
          onClick={handleOpen}
          style={{ display: "inline-block", cursor: "pointer", ...style }}
          {...rest}
        >
          {children || label}
        </span>
      ) : (
        <button
          type="button"
          id={id}
          className={`btn ${className}`.trim()}
          style={style}
          onClick={handleOpen}
          {...rest}
        >
          {children || label}
        </button>
      )}

      <Modal
        show={showModal}
        onHide={handleClose}
        size="lg"
        fullscreen="md-down"
        centered
        className="gcal-appointment-modal"
        dialogClassName="gcal-appointment-dialog"
      >
        <Modal.Header closeButton className="gcal-modal-header">
          <Modal.Title className="gcal-modal-title">
            {modalTitle || label || "Schedule an Appointment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="gcal-modal-body p-0">
          <iframe
            src={url}
            title={modalTitle || label || "Google Calendar Appointment Scheduling"}
            style={{ border: 0, width: "100%", height: "650px", minHeight: "550px", display: "block" }}
            width="100%"
            height="650"
            frameBorder="0"
          />
        </Modal.Body>
        <Modal.Footer className="gcal-modal-footer d-flex justify-content-between align-items-center">
          <small className="text-muted">
            Completed your booking? Click Done to return.
          </small>
          <button type="button" className="btn btn-main px-4 py-2" onClick={handleClose}>
            Done / Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
